import {useApp} from "../app.context";
import {useIntegrator} from "../integrator.context";
import AssetImage from "./assetImage.element";
import Checkmark from "./checkmark";

interface AttributeLabelProps {
    uid: string;
    suffix?: string;
    // When non-empty, decorates the label with a warning icon and red border;
    // the string becomes the hover tooltip. Used for unmet dependencies.
    warning?: string;
    onDelete?(): void;
}

function findMetadataId(state: any, uid: string): string | null {
    const collections = [state.unitAttributes, state.buildingAttributes, state.techActionAttributes, state.techPassiveAttributes, state.rewards];
    for (const col of collections) {
        if (!col) continue;
        const meta = col.find((m: any) => m.uid === uid);
        if (meta) return meta.id;
    }
    return null;
}

function MetadataLabel(props: AttributeLabelProps) {
    const {setNotification, getLocalizationValue, confirmDelete} = useApp();
    const {state} = useIntegrator();
    const locKey = props.uid;
    const metaId = findMetadataId(state, props.uid);
    const descKey = metaId ? `${metaId}.description` : `${props.uid}.description`;

    const hasWarning = !!props.warning;

    return (
        <div className={'layout horizontal center stretch gap label'}
             title={props.warning}
             style={hasWarning ? {border: 'solid 1px #ff6666', borderRadius: 'var(--border-radius)'} : undefined}>
            <div className={'layout horizontal gap center'}>
                <div style={{position: 'relative'}}>
                    <AssetImage id={props.uid}/>
                    <Checkmark id={props.uid} style={{position: 'absolute', top: 2, right: 2}}/>
                </div>
                <p style={{width: 160, padding: 5}}
                   onClick={() => setNotification({title: locKey, message: descKey, edit: true})}
                >
                    {getLocalizationValue(locKey)}{props.suffix ?? ''}
                </p>
                {hasWarning && <span className={'fa-solid fa-triangle-exclamation'}
                                     style={{color: '#ff6666', marginRight: 6}}/>}
            </div>
            {props.onDelete && <button style={{marginRight: 8}}>
                <span className={'fa-solid fa-trash'} style={{color: 'white'}} onClick={async (e) => {
                    e.stopPropagation();
                    if (props.onDelete && await confirmDelete(getLocalizationValue(locKey))) {
                        props.onDelete();
                    }
                }}/>
            </button>}
        </div>
    )
}

export default MetadataLabel;